import {createAction} from '@reduxjs/toolkit'
import {isEventDetailsPageHiddenInternal} from '@wix/wix-events-commons-statics'
import {IWixAPI} from '@wix/yoshi-flow-editor'
import {navigateToDetailsPage} from '../../../../commons/services/navigation'
import {isEventRestricted} from '../selectors/events'
import {createAsyncAction} from '../services/redux-toolkit'
import {GetState} from '../types/state'
import {ensureLoggedIn, ensureLoggedInOld} from './members'

export const navigateToPageOld =
  (event: wix.events.Event) =>
  async (dispatch, getState: GetState, {wixCodeApi}: {wixCodeApi: IWixAPI}) => {
    dispatch(rsvpButtonClicked({event}))
    const state = getState()
    const detailsPageEnabled = !isEventDetailsPageHiddenInternal(event)

    const isRestricted = isEventRestricted(state, event)
    if (!isRestricted || (await dispatch(ensureLoggedInOld()))) {
      await navigateToDetailsPage(event, detailsPageEnabled, wixCodeApi)
      dispatch(navigatedToPage({event}))
    }
  }

export const navigateToPage = createAsyncAction<boolean, {event: wix.events.Event}>(
  'NAVIGATE_TO_PAGE',
  async ({event}, {dispatch, getState, extra: {wixCodeApi}}) => {
    dispatch(rsvpButtonClicked({event}))
    const state = getState()
    const detailsPageEnabled = !isEventDetailsPageHiddenInternal(event)

    const isRestricted = isEventRestricted(state, event)
    if (!isRestricted || (await dispatch(ensureLoggedIn()))) {
      await navigateToDetailsPage(event, detailsPageEnabled, wixCodeApi)

      return true
    }

    return false
  },
)

export const onLinkNavigatedToPage = createAction<{event: wix.events.Event}>('ON_LINK_NAVIGATED_TO_PAGE')

export const rsvpButtonClicked = createAction<{event: wix.events.Event}>('RSVP_BUTTON_CLICKED')

export const navigatedToPage = createAction<{event: wix.events.Event}>('NAVIGATED_TO_PAGE')
